import script from "./DeploymentStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./DeploymentStatus.vue?vue&type=script&setup=true&lang=js"

import "./DeploymentStatus.vue?vue&type=style&index=0&id=cfa647d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfa647d4"]])

export default __exports__